import { render, staticRenderFns } from "./RevenueSplitFinalizedList.vue?vue&type=template&id=4002a7f6&scoped=true"
import script from "./RevenueSplitFinalizedList.vue?vue&type=script&lang=js"
export * from "./RevenueSplitFinalizedList.vue?vue&type=script&lang=js"
import style0 from "./RevenueSplitFinalizedList.vue?vue&type=style&index=0&id=4002a7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4002a7f6",
  null
  
)

export default component.exports